import { render, staticRenderFns } from "./MassActions.vue?vue&type=template&id=03672f12"
import script from "./MassActions.vue?vue&type=script&lang=js"
export * from "./MassActions.vue?vue&type=script&lang=js"
import style0 from "./MassActions.vue?vue&type=style&index=0&id=03672f12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports